import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    dateTitle: {
        id: '_.draw_down.iwocaPay.order_summary.table.date_title',
        defaultMessage: 'Date'
    },
    principleTitle: {
        id: '_.draw_down.iwocaPay.order_summary.table.principle_title',
        defaultMessage: 'Invoice amount'
    },
    interestTitle: {
        id: '_.draw_down.iwocaPay.order_summary.table.interest_title',
        defaultMessage: 'Interest*'
    },
    totalTitle: {
        id: '_.draw_down.iwocaPay.order_summary.table.total_title',
        defaultMessage: 'Total'
    }
});
